"use strict";
function openWindow(theURL, { height = 600, width = 600, popup = 'true', target = 'newWindow' } = {}, onFail) {
    const newWindow = window.open(theURL, target, 'height=' + height + ',width=' + width + ',popup=' + popup);
    if (newWindow) {
        newWindow.focus();
    }
    else if (onFail) {
        onFail();
    }
}
window.openWindow = openWindow;
